import React from 'react';
import { useLocation } from 'react-router';
import { LanguageSettingsDropdown } from 'components/Header/LanguageSettingsDropdown';
import { useAuth } from 'providers/useAuth/AuthContext';
import translate from 'utils/fnTranslate';
import { StaticPageRoutes, FAVORITES_CUSTOM_ATTR_ID } from 'types/RouteTypes';
import { FooterWrapper, InternalLink, LinksBlock } from './Footer.css';
import { useScreenState } from '../../hooks/useScreenState/useScreenState';
import { usePageScroller } from '../PageScroller/usePageScroller';
import { useSearch } from '../../providers/useSearch/SearchContext';
import { useNavigationData } from '../../providers/useNavigation/NavigationContext';
import { getMenuItemPath, isMenuItemActive } from '../../utils/fnRouting';
import { savePageInfo } from '../../utils/pageInfoStorage';

const FooterMenu: React.FC = () => {
    const { getNavigationItems } = useNavigationData();
    const { pathname } = useLocation();
    const { isGuest } = useAuth();

    const { emptyStates } = useScreenState();
    const { scrollTo } = usePageScroller();
    const { exitSearch } = useSearch();

    const navigationItems = getNavigationItems().filter((item) => !(isGuest && item.customAttributesId === FAVORITES_CUSTOM_ATTR_ID));

    const isA11yNotice = window.location.href.includes('accessibility-notice');

    const handleMenuItemClick = (path: string) => {
        if (path) {
            emptyStates(path);
        }
        scrollTo(0);
        exitSearch(false);
    };

    return (
        <>
            {navigationItems.map((item, index) => {
                const path = getMenuItemPath(item);
                const text = item.title;

                return (
                    <InternalLink
                        active={isMenuItemActive(pathname, path, index) ? 'active' : null}
                        aria-current={isMenuItemActive(pathname, path, index) ? 'page' : undefined}
                        key={index}
                        to={path}
                        target={''}
                        onClick={() => {
                            savePageInfo('');
                            emptyStates(path);
                            scrollTo(0);
                            exitSearch(false);
                        }}
                        data-event-name={'click'}
                        data-track-id={`menu_footer_${text.toLowerCase()}`}
                        data-test-id={`footer-menu-${text.toLowerCase()}`}
                    >
                        {text}
                    </InternalLink>
                );
            })}
            <InternalLink
                active={isA11yNotice ? 'true' : undefined}
                aria-current={isA11yNotice ? 'page' : undefined}
                to={StaticPageRoutes.ACCESSIBILITY_NOTICE}
                onClick={() => handleMenuItemClick(StaticPageRoutes.ACCESSIBILITY_NOTICE)}
                data-event-name="click"
                data-track-id="menu_footer_accessibility-notice"
                data-test-id="footer-menu-accessibility-notice"
            >
                {translate('SETTINGS_ACCESSIBILITY_NOTICE_LINK')}
            </InternalLink>
        </>
    );
};

export const Footer: React.FC = () => (
    <FooterWrapper id={'Footer'} data-test-id={'footer'}>
        <>
            <LinksBlock>
                <FooterMenu />
            </LinksBlock>
            <LanguageSettingsDropdown />
        </>
    </FooterWrapper>
);
